import defaultApp from './defaultApp.js';
import Datepicker from 'vanillajs-datepicker/Datepicker';

import AgendaItem from './components/AgendaItem.vue';
import AgendaSkeleton from './components/AgendaSkeleton.vue';
import BlockItem from './components/BlockItem.vue';
import BannerItem from './components/BannerItem.vue';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(Datepicker.locales, nl);

const datePickerOptions = {
    format: 'dd-mm-yyyy',
    nextArrow: '<i class="fa-solid fa-angle-right"></i>',
    prevArrow: '<i class="fa-solid fa-angle-left"></i>'
}

const agendaApp = {
    ...defaultApp,
    components: { AgendaItem, AgendaSkeleton, BlockItem, BannerItem },
    data() {
        return {
            ...defaultApp.data(),
            dataTodayLabel: 'vandaag',
            dataWeekendLabel: 'dit weekend',
            dataWeekLabel: 'deze week',
            dataMonthLabel: 'deze maand',
            filtersOpen: false,
            datepicker: null,
            filterDate: '',
            customDateButtons: {},
            wishlist: []
        }
    },
    computed: {
        ...defaultApp.computed,
        filterItems() {
            if (this.dataOverruleCmsIds.length) {
                return [{
                    Key: this.constants.keys.cmsId,
                    Values: this.dataOverruleCmsIds,
                    Operator: this.constants.operators.in
                }]
            }
            let tempFilterArray = [];
            if (this.dataTarget) {
                tempFilterArray = [{
                    Key: this.constants.keys.location,
                    Values: [this.dataTarget],
                    Operator: this.constants.operators.in
                }];
            }
            if (!this.filtersChosen) return tempFilterArray;
            
            if (this.dataExcludeProductions.length) {
                tempFilterArray.push({
                    Key: this.constants.keys.cmsId,
                    Values: this.dataExcludeProductions,
                    Operator: this.constants.operators.notIn
                });
            }
            if (this.dataGenreOverrule.length) {
                tempFilterArray.push({
                    Key: this.constants.keys.genre,
                    Values: this.dataGenreOverrule,
                    Operator: this.constants.operators.in
                });
            }
            if (this.dataTagsOverrule.length && !this.dataGenreOverrule.length) {
                tempFilterArray.push({
                    Key: this.constants.keys.tags,
                    Values: this.dataTagsOverrule,
                    Operator: this.constants.operators.in
                });
            }
            if (this.data.items.length && this.dataWidget) {
                tempFilterArray.push({
                    Key: this.constants.keys.cmsId,
                    Values: this.data.items.map(item => item.cmsId),
                    Operator: this.constants.operators.notIn
                });
            }
            const locationFacet = this.data.facets.find(facet => facet.alias === this.constants.keys.location);
            if (locationFacet && locationFacet.values.length) {
                if (locationFacet.values[0] !== this.dataTarget) {
                    tempFilterArray = [{
                        Key: locationFacet.alias,
                        Values: locationFacet.values,
                        Operator: this.constants.operators.in
                    }];
                }
            }
            const otherFacets = this.data.facets.filter(facet => facet.alias !== this.constants.keys.location && facet.alias !== this.constants.keys.date);
            otherFacets.forEach(facet => {
                if (facet.values.length) {
                    tempFilterArray.push({
                        Key:facet.alias,
                        Values: facet.values,
                        Operator: this.constants.operators.in
                    });
                }
            });

            if (this.searchFrom) {
                tempFilterArray.push({
                    Key: this.constants.keys.dateStart,
                    Values: [this.searchFrom],
                    Operator: this.constants.operators.greaterThan
                });

                if (this.searchTo) {
                    tempFilterArray.push({
                        Key: this.constants.keys.dateStart,
                        Values: [this.searchTo],
                        Operator: this.constants.operators.lowerThan
                    });
                }
            }
            return tempFilterArray;
        },
        daterangeSet() {
            return Object.values(this.customDateButtons).some(button => button.selected);
        },
        allDays() {
            if (!this.data.facets.length) return [];
            let dateFacet = this.data.facets.find(facet => facet.alias === this.constants.keys.date);
            if (!dateFacet) return [];
            let dates = dateFacet.options.filter(option => option.filteredAmount).map(option => new Intl.DateTimeFormat(this.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(this.toDateObj(option.valueAlias)));

            if (!this.filterDate) {
                Object.values(this.customDateButtons).forEach(button => {
                    let from = new Intl.DateTimeFormat(this.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(this.toDateObj(button.from));
                    let to = new Intl.DateTimeFormat(this.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(this.toDateObj(button.to));
                    if (!dates.includes(from) && !dates.includes(to)) {
                        button.disabled = true;
                    } else {
                        button.disabled = false;
                    }
                });
            }

            return dates;
        },
        wishlistIds() {
            let result = this.wishlist.map(event => event.id);
            return result;
        }
    },
    methods: {
        ...defaultApp.methods,
        getSelectedDateButton() {
            return Object.values(this.customDateButtons).find(button => button.selected)?.label
        },
        setData(response, replace = false) {
            if (!response || response.status != 200 || !response.data) return;
            if (!this.itemsSet || replace) {
                this.data.items = this.dataWidget ? response.data : response.data.items.map(i => ({ ...i, type: 'event', favourite: this.wishlistIds.some(wishlistId => wishlistId === i.id) }))
            } else {
                if (this.dataWidget) {
                    response.data.forEach(item => {
                        item.favourite = this.wishlistIds.some(wishlistId => wishlistId === item.id);
                        this.data.items.push(item);
                    });
                } else {
                    response.data.items.map(i => ({ ...i, type: 'event', favourite: this.wishlistIds.some(wishlistId => wishlistId === i.id) })).forEach(item => {
                        this.data.items.push(item);
                    });
                }
            }
            if (this.banners.length) this.data.items = this.mergeArrays(this.data.items, this.banners);
            if (!this.dataWidget) this.setFacets(response);

            this.$nextTick(() => {
                if (this.datepicker === null && this.$refs.datepicker) {
                    const self = this;
                    datePickerOptions.defaultViewDate = this.allDays[0];
                    datePickerOptions.language = this.language;
                    // Logica voorlopig laten staan tot na goedkeuring klant
                    //datePickerOptions.datesDisabled = function (date) {
                    //    return !self.allDays.includes(new Intl.DateTimeFormat(self.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date));
                    //}
                    this.datepicker = new Datepicker(this.$refs.datepicker[0], datePickerOptions);

                    if (this.filterDate) this.datepicker.setDate(this.filterDate);
                    this.$refs.datepicker[0].addEventListener('changeDate', (e) => {
                        let filterdate = '';
                        if (e.detail.date !== undefined) {
                            self.filterDate = new Intl.DateTimeFormat(self.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(self.toDateObj(e.detail.date));
                            filterdate = self.reverseDate(self.filterDate);
                            self.searchFrom = '';
                            self.searchTo = '';
                            Object.values(this.customDateButtons).forEach(button => {
                                button.selected = false;
                            });
                        } else {
                            self.filterDate = '';
                        }
                        if (!self.searchTo) {
                            const index = self.filterItems.findIndex(item => item.Key === this.constants.keys.dateStart);
                            if (index > -1) {
                                self.filterItems.splice(index, 1);
                            }
                        }
                        if (filterdate.length) {
                            self.searchFrom = self.toDateObj(filterdate).toISOString();
                            self.fetchInitialData();
                        }
                        this.closeFacets();
                    });
                    this.$refs.datepicker[0].addEventListener('change', (e) => {
                        if (e.target.value === '') {
                            self.searchFrom = '';
                            self.filterDate = '';
                            this.closeFacets();
                            self.fetchInitialData();
                        }
                    });
                }
            });
        },
        reverseDate(dateString) {
            var dateStringComps = dateString.split("-");
            return dateStringComps[2] + "-" + dateStringComps[1] + "-" + dateStringComps[0]
        },
        setDateRange(button) {
            const index = this.filterItems.findIndex(item => item.Key === this.constants.keys.date);
            if (index > -1) {
                this.filterItems.splice(index, 1);
            }
            this.filterDate = '';
            this.datepicker.setDate({ clear: true });
            Object.values(this.customDateButtons).forEach(button => button.selected = false);
            button.selected = true;
            this.searchFrom = button.from;
            this.searchTo = button.to;
            this.closeFacets();
            this.fetchInitialData();
        },
        resolveParams() {
            const urlParams = new URLSearchParams(window.location.search);

            let pageParam = urlParams.has(this.constants.queryParams.page) ? parseInt(urlParams.get(this.constants.queryParams.page)) : 0;
            if (pageParam) urlParams.delete(this.constants.queryParams.page);
            if (pageParam < 2) pageParam = 0;
            this.searchText = urlParams.has(this.constants.queryParams.text) ? urlParams.get(this.constants.queryParams.text) : '';
            if (this.searchText) urlParams.delete(this.constants.queryParams.text);
            let filterParams = urlParams.toString() ? urlParams : null;
            // Preset values for facets based on query params.
            if (filterParams) {
                let filterQuery = this.filterItems;
                const startParams = filterParams.getAll(this.constants.keys.dateStart);
                if (startParams.length) {
                    if (startParams.length > 1) {
                        this.filterDate = '';
                        const [fromParam, toParam] = startParams.sort();
                        const matchingButton = Object.keys(this.customDateButtons).find((key) => {
                            const { from, to } = this.customDateButtons[key];
                            return from === fromParam && to === toParam;
                        });
                        if (matchingButton) {
                            this.customDateButtons[matchingButton].selected = true;
                            this.searchFrom = this.customDateButtons[matchingButton].from;
                            this.searchTo = this.customDateButtons[matchingButton].to;
                            filterQuery.push({
                                Key: this.constants.keys.dateStart,
                                Values: [this.searchFrom],
                                Operator: this.constants.operators.greaterThan
                            },
                            {
                                Key: this.constants.keys.dateStart,
                                Values: [this.searchTo],
                                Operator: this.constants.operators.lowerThan
                            });
                        }
                    } else {
                        this.searchFrom = startParams[0];
                        this.filterDate = new Intl.DateTimeFormat(this.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(this.toDateObj(this.searchFrom));
                        filterQuery.push({
                            Key: this.constants.keys.dateStart,
                            Values: [this.searchFrom],
                            Operator: this.constants.operators.greaterThan
                        });
                    }
                }
                filterParams.forEach((value, key) => {
                    if (key !== this.constants.keys.dateStart) {
                        filterQuery.push({ Key: key, Values: value.split(','), Operator: this.constants.operators.in });
                    }
                });
                this.queryModel.FilterItems = filterQuery;
            }
            if (pageParam && !this.dataWidget) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit * this.page;
            }
        },
        clearAllDates() {
            this.searchFrom = '';
            this.searchTo = '';
            Object.values(this.customDateButtons).forEach(button => {
                button.selected = false;
            });
            this.filterDate = '';
            this.datepicker.setDate({ clear: true });
            const index = this.filterItems.findIndex(item => item.Key === this.constants.keys.date);
            if (index > -1) {
                this.filterItems.splice(index, 1);
            }
            this.$nextTick(() => {
                this.datepicker.update();
            });
            this.fetchInitialData();
        },
        reset() {
            this.data.facets.forEach(facet => facet.values = []);
            this.searchFrom = '';
            this.searchTo = '';
            Object.values(this.customDateButtons).forEach(button => {
                button.selected = false;
            });
            this.filterDate = '';
            this.datepicker.setDate({ clear: true });
            const index = this.filterItems.findIndex(item => item.Key === this.constants.keys.date);
            if (index > -1) {
                this.filterItems.splice(index, 1);
            }
            this.$nextTick(() => {
                this.datepicker.update();
            });
            this.searchText = '';
            this.loading = true;
            this.fetchInitialData();
            this.loading = false;
        },
        mergeArrays(items, banners) {
            const lastEventDate = new Date(items[items.length - 1].start);

            const visibleBanners = banners
                .filter(b => new Date(b.start) <= lastEventDate);

            this.banners = this.banners.filter(b => new Date(b.start) > lastEventDate);

            const merged = [
                ...items,
                ...visibleBanners
            ].sort((a, b) => new Date(a.start) - new Date(b.start));

            return merged
        },
        selectOption(facetAlias, optionAlias) {
            let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
            let changedOption = changedFacet.options.find(option => option.valueAlias === optionAlias);
            changedFacet.values = [];
            changedFacet.options.forEach(option => {
                option.selected = false;
            });
            changedFacet.values.push(optionAlias);
            changedOption.selected = true;
            changedFacet.selected = changedFacet.values.length;
            this.closeFacets();
            this.fetchInitialData();
        },
        resetMultiDropdown(facetAlias) {
            let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
            changedFacet.values = [];
            changedFacet.options.forEach(option => {
                option.selected = false;
            });
            changedFacet.selected = false;
            this.closeFacets();
            this.fetchInitialData();
        },
        openFilters() {
            this.filtersOpen = true;
            document.documentElement.classList.add('has-filters-open');
        },
        closeFilters() {
            this.filtersOpen = false;
            document.documentElement.classList.remove('has-filters-open');
            
        },
        toggleFacet(i) {
            if (this.facetState[i].facetOpen) {
                this.facetState[i].facetOpen = false;
            } else {
                this.closeFacets();
                this.facetState[i].facetOpen = true;
            }
        },
        closeFacets() {
            this.facetState = this.facetState.map(item => {
                return { ...item, facetOpen: false };
            });
        }
    },
    updated() {
        if (this.datepicker !== null) {
            let self = this;
            // Logica voorlopig laten staan tot na goedkeuring klant
            //datePickerOptions.datesDisabled = function (date) {
            //    return !self.allDays.includes(new Intl.DateTimeFormat(self.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date));
            //}
            datePickerOptions.defaultViewDate = this.allDays[0];
            this.datepicker.setOptions(datePickerOptions);
        }
    },
    created() {
        const now = new Date();

        // Today
        const todayFrom = new Date(now.setHours(0, 0, 0, 0)).toISOString();
        const todayTo = new Date(now.setHours(23, 59, 59, 999)).toISOString();

        // Weekend (Upcoming Saturday to Sunday)
        let day = now.getDay(); // 0 = Sunday, 6 = Saturday
        let saturday = new Date(now);
        saturday.setDate(now.getDate() + (day >= 6 ? 7 - day : 6 - day)); // Move to next Saturday
        saturday.setHours(0, 0, 0, 0);

        let sunday = new Date(saturday);
        sunday.setDate(saturday.getDate() + 1); // Move to Sunday
        sunday.setHours(23, 59, 59, 999);

        const weekendFrom = saturday.toISOString();
        const weekendTo = sunday.toISOString();

        // Week (Today to upcoming Sunday)
        let weekFrom = new Date(todayFrom);
        let weekTo = new Date(now);
        weekTo.setDate(now.getDate() + (7 - day)); // Move to next Sunday
        weekTo.setHours(23, 59, 59, 999);

        // Month (Today to last day of the month)
        let monthFrom = new Date(todayFrom);
        let lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        lastDay.setHours(23, 59, 59, 999);

        const monthTo = lastDay.toISOString();
        this.customDateButtons = {
            today: { id: 'dateButton1', label: this.dataTodayLabel, from: todayFrom, to: todayTo, selected: false, disabled: false },
            weekend: { id: 'dateButton2', label: this.dataWeekendLabel, from: weekendFrom, to: weekendTo, selected: false, disabled: false },
            week: { id: 'dateButton3', label: this.dataWeekLabel, from: weekFrom.toISOString(), to: weekTo.toISOString(), selected: false, disabled: false },
            month: { id: 'dateButton4', label: this.dataMonthLabel, from: monthFrom.toISOString(), to: monthTo, selected: false, disabled: false }
        }
        this.changeSearchText = this.debounce(() => {
            this.fetchInitialData();
        });

        let mql = window.matchMedia('(min-width: 1024px)');

        mql.addEventListener('change', event => {
            if (event.matches) {
                this.filtersOpen = false;
                document.documentElement.classList.remove('has-filters-open');
            }
        })
    },
    mounted() {
        this.wishlist = localStorage.hasOwnProperty('wishlist') ? JSON.parse(localStorage.wishlist) : [];
        let self = this;
        window.addEventListener('wishlist-localstorage-changed', (event) => {
            self.wishlist = JSON.parse(event.detail.storage);
            self.data.items = self.data.items.map(item => {
                return {
                    ...item,
                    favourite: self.wishlistIds.some(wishlistId => wishlistId === item.id),
                }
            });
        });
        this.init();
    }
};

export default agendaApp;